import React from "react";
import kiraLogo from "../../../assets/Kira.png";

interface SubtitleViewProps {
  subtitleOrig: string;
  subtitleTran: string;
}

export const SubtitleView: React.FC<SubtitleViewProps> = ({ subtitleOrig, subtitleTran }) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6 md:p-12 overflow-y-auto min-h-0">
      {!subtitleOrig && !subtitleTran && (
        <div className="max-w-[480px] w-full text-center flex flex-col items-center animate-fade-in my-auto">
          <div className="w-[220px] h-[220px] mb-[20px] flex items-center justify-center relative">
            <img
              src={kiraLogo}
              className="max-w-full max-h-full object-contain filter drop-shadow-[0_8px_16px_rgba(0,0,0,0.35)] animate-[gentle-float_6s_ease-in-out_infinite]"
              alt="Kira Logo"
            />
          </div>
          <p className="text-[12.5px] text-[var(--accent)] font-medium mb-[24px]">
            Traductor en tiempo real
          </p>

          <div className="w-full bg-white/[0.015] border border-[var(--border)] py-[16px] px-[18px] rounded-[10px] text-left space-y-[10px] mb-[22px]">
            {[
              "Elige los idiomas de origen y destino en la barra superior.",
              <><strong className="text-[var(--text)] font-semibold">Haz clic en Start</strong> y selecciona la pestaña o ventana del sistema con audio.</>,
              "¡Listo! Kira capturará el audio y mostrará la traducción al instante.",
            ].map((step, i) => (
              <div key={i} className="flex gap-[10px] items-start">
                <span className="w-[18px] h-[18px] rounded-full bg-white/[0.08] flex items-center justify-center text-[10px] font-semibold text-[var(--text-muted)] flex-shrink-0 mt-[1px]">
                  {i + 1}
                </span>
                <p className="text-[12px] text-[var(--text-muted)] leading-[1.4]">{step}</p>
              </div>
            ))}
          </div>

          <div className="inline-flex items-center gap-[8px] border border-[var(--border)] bg-white/[0.03] rounded-full px-[14px] py-[4px] text-[10.5px] font-mono text-[var(--text-dim)]">
            <span className="w-[6px] h-[6px] bg-[var(--text-dim)] rounded-full inline-block animate-pulse" />
            Esperando audio del sistema...
          </div>
        </div>
      )}

      {/* Active subtitles */}
      {(subtitleOrig || subtitleTran) && (
        <div className="w-full max-w-4xl mx-auto flex flex-col justify-center items-center gap-6 my-auto">
          <p className="text-sm md:text-base text-[var(--text-muted)] max-w-2xl text-center leading-relaxed font-sans font-medium px-4 select-text">
            {subtitleOrig}
          </p>
          <div className="w-12 h-[1px] bg-[var(--border)]" />
          <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-[var(--text)] text-center leading-tight tracking-tight px-4 filter drop-shadow-md select-text">
            {subtitleTran}
          </p>
        </div>
      )}
    </div>
  );
};
